export type CreateStripeBillingPortalRequestBody =
  | MainPortalRequest
  | UpdatePaymentMethodRequest
  | CancelPortalRequest
  | UpdateSubscriptionRequest;

export type MainPortalRequest = {
  action: StripeBillingPortalAction.MainPortal;
  returnUrl: string;
};

export type UpdatePaymentMethodRequest = {
  action: StripeBillingPortalAction.UpdatePaymentMethod;
  returnUrl: string;
};

export type CancelPortalRequest = {
  action: StripeBillingPortalAction.Cancel;
  returnUrl: string;
  stripeSubscriptionId: string;
};

export type UpdateSubscriptionRequest = {
  action: StripeBillingPortalAction.UpdateSubscription;
  returnUrl: string;
  stripeSubscriptionId: string;
};

export enum StripeBillingPortalAction {
  /**
   * Go to the main portal where all functionality is enabled.
   * This is less convenient, as the user needs to locate the plan for their
   * account first, and then click on it.
   *
   * This is currently the only way to renew a scheduled cancellation.
   */
  MainPortal = "mainPortal",

  /**
   * Jump straight to the payment update dialogue, so the user can change their
   * card details.
   */
  UpdatePaymentMethod = "updatePaymentMethod",

  /**
   * Jump straight to the cancel subscription dialogue for the provided
   * subscription.
   */
  Cancel = "cancel",

  /**
   * Jump straight to the plan selection dialogue for the provided
   * subscription, so a plan upgrade or downgrade can occur.
   *
   * Cancelling and Renewing is not supported.
   */
  UpdateSubscription = "updateSubscription",
}
